import { TrackEvent } from 'livekit-client';
import { log } from '@livekit/components-core';
import { IDeviceFollower } from './types';

export const followTheDeviceOf = ({
  kind,
  onDeviceChange,
  previewRoom,
  track,
}: IDeviceFollower) => {
  if (!track) {
    return undefined;
  }
  const showTheDevice = async () => {
    const deviceId = await track.getDeviceId(false);
    if (deviceId) {
      onDeviceChange(deviceId);
      await previewRoom.switchActiveDevice(kind, deviceId);
    }
  };
  const followTheDevice = () => {
    showTheDevice().catch(error =>
      log.warn('could not follow the chosen device', error),
    );
  };
  track.on(TrackEvent.Restarted, followTheDevice);
  return () => {
    track.off(TrackEvent.Restarted, followTheDevice);
  };
};
